import { render, staticRenderFns } from "./AddressLookup.vue?vue&type=template&id=bbd89f52&"
import script from "./AddressLookup.vue?vue&type=script&lang=js&"
export * from "./AddressLookup.vue?vue&type=script&lang=js&"
import style0 from "./AddressLookup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports